import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/cogniflock_logo_full.svg";
import { getApiBaseUrl } from "../utils/apiConfig";

const EmailVerification = () => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const apiUrl = getApiBaseUrl();
      const res = await axios.post(
        `${apiUrl}/auth/verify-email`,
        { email, code }
      );
      // Assuming the response contains a token and user data
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      if (res.data.user.onboardingCompleted) {
        navigate("/dashboard");
      } else {
        navigate("/onboarding");
      }
    } catch (err) {
      console.error(err);
      setError("Invalid verification code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
      <div className="w-full max-w-sm p-6 flex flex-col gap-10">
        <img src={logo} alt="Logo" className="h-9" />
        <div className="relative w-full flex flex-col gap-3">
          <div className="w-full max-w-md flex flex-col gap-4 p-6 bg-white-f border border-grey-20 rounded-xl shadow-sm">
            <h2 className="text-xl  font-normal text-black-0">
              Verify Your Email
            </h2>
            <p className="text-sm  font-normal text-grey-60">
              Enter the 6-digit code sent to{" "}
              <span className="font-semibold">{email}</span>.
            </p>
            <form onSubmit={handleVerify} className="flex flex-col gap-4">
              <input
                className="w-full px-3 py-1 border border-grey-30 rounded-md focus:outline-none"
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter verification code"
              />
              <button
                className="w-full py-2 px-4 bg-brand text-white-f text-sm  font-medium tracking-wide rounded-md hover:bg-brand-dark transition"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <div className="inline-block align-middle w-4 h-4 border-2 border-t-2 border-t-white-f border-bg-opacity rounded-full animate-spin"></div>
                ) : (
                  "Verify"
                )}
              </button>
              {error && (
                <p className="flex items-center text-red-strong text-sm  font-normal px-2 py-1 bg-red-light rounded-md mt-2">
                  {error}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
